import type { DemoKey } from '../types';

export const zh: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': '数学 · 统计学',
  'app.title': '统计学',
  'panel.experiment': '场景',
  'panel.params': '参数',

  'exp.survey-explorer.title': '调查浏览器',
  'exp.survey-explorer.desc': '选择一列；演示会自动选择合适的汇总方式。',
  'exp.distribution-sculptor.title': '分布雕塑',
  'exp.distribution-sculptor.desc': '拖动点,观察统计量如何响应。',
  'exp.two-variable-lab.title': '双变量实验室',
  'exp.two-variable-lab.desc': '散点、拟合、并思考因果关系。',
  'exp.sampling-lab.title': '抽样实验室',
  'exp.sampling-lab.desc': '抽样方法与样本量如何影响样本均值。',
  'exp.probability-diagrams.title': '概率图',
  'exp.probability-diagrams.desc': '复合事件的韦恩图与树形图。',

  'type.qualitative-nominal.label': '定性 · 名义',
  'type.qualitative-nominal.def': '无固有顺序的类别。',
  'type.qualitative-ordinal.label': '定性 · 有序',
  'type.qualitative-ordinal.def': '有明确顺序的类别。',
  'type.qualitative-multi.label': '定性 · 多值',
  'type.qualitative-multi.def': '每个观测可有多个标签。',
  'type.quantitative-discrete.label': '定量 · 离散',
  'type.quantitative-discrete.def': '以固定步长出现的数值。',
  'type.quantitative-continuous.label': '定量 · 连续',
  'type.quantitative-continuous.def': '在连续尺度上测量的数值。',

  'column.name.label': '学生姓名',
  'column.height_cm.label': '身高',
  'column.shoe_size_eu.label': '鞋码 (欧码)',
  'column.study_hours.label': '每周学习时数',
  'column.test_score.label': '考试分数',
  'column.sports_played.label': '所玩运动',
  'column.eye_color.label': '眼睛颜色',
  'column.commute_min.label': '通勤时间',
  'column.grade_year.label': '年级',
  'column.homework_effort.label': '作业投入',
  'column.ice-cream-sales.label': '冰淇淋销量',
  'column.drownings.label': '溺水人数',
  'column.month.label': '月份',
  'column.storks.label': '鹳数量',
  'column.births.label': '出生数',
  'column.country_area_km2.label': '国土面积',
  'column.sleep_hours.label': '睡眠时数',
  'column.reaction_ms.label': '反应时间',

  'dataset.master-survey.label': '班级调查',
  'dataset.master-survey.desc': '30 名模拟学生。',
  'dataset.spurious-ice-cream-vs-drownings.label': '冰淇淋销量 vs 溺水',
  'dataset.spurious-ice-cream-vs-drownings.desc': '两者都随季节起伏。溺水不会引起冰淇淋销量。',
  'dataset.spurious-storks-vs-births.label': '鹳 vs 出生',
  'dataset.spurious-storks-vs-births.desc': '更大的国家有更多鹳和更多新生儿。鸟不是原因。',
  'dataset.real-sleep-vs-reaction-time.label': '睡眠 vs 反应时间',
  'dataset.real-sleep-vs-reaction-time.desc':
    '睡得越多,反应越快。一个真实的负相关——并且有合理的机制。',

  'tag.football.label': '足球',
  'tag.basketball.label': '篮球',
  'tag.volleyball.label': '排球',
  'tag.swimming.label': '游泳',
  'tag.none.label': '无',

  'population.gaussian.label': '钟形曲线',
  'population.right-skewed.label': '右偏',
  'population.bimodal.label': '双峰 (含层级)',
  'population.uniform.label': '均匀',

  'venn.dice-even-or-prime.label': '骰子:偶数或质数',
  'venn.class-sports-2set.label': '班级运动 (2 集合)',
  'venn.class-sports-3set.label': '班级运动 (3 集合)',
  'venn.custom.label': '自定义',

  'tree.draw-without-replacement.label': '不放回抽取',
  'tree.custom.label': '自定义',
  'tree.coin.heads': '正',
  'tree.coin.tails': '反',
  'tree.draw.start': '袋子:2 红,3 蓝',
  'tree.draw.red': '红',
  'tree.draw.blue': '蓝',
  'tree.custom.start': '开始',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': '直方图',
  'card.cumulative': '累计频数',
  'card.box': '箱线图',
  'card.summary': '五数概括',
  'card.bar': '条形图',
  'card.mode': '众数',
  'card.tag-frequency': '标签频率',
  'card.mode-tag': '最常见标签',
  'card.empty-no-order': '不适用',
  'card.empty-multi': '不适用',
  'card.numberline': '数轴',
  'card.scatter': '散点图',
  'card.description': '正在发生',
  'card.population': '总体',
  'card.sampling-distribution': '样本均值',
  'card.venn': '韦恩图',
  'card.tree': '树形图',
  'card.probabilities': '概率',

  'param.dataset.label': '数据集',
  'param.column.label': '列',
  'param.bins.label': '区间',
  'param.shape.label': '初始形状',
  'param.show-mean.label': '显示均值',
  'param.show-median.label': '显示中位数',
  'param.x-col.label': 'X 列',
  'param.y-col.label': 'Y 列',
  'param.show-regression.label': '回归线',
  'param.show-residuals.label': '残差',
  'param.show-confounder.label': '显示混杂因素',
  'param.population.label': '总体',
  'param.technique.label': '方法',
  'param.sample-size.label': '样本量',
  'param.stratum.label': '层',
  'param.bias.label': '偏差',
  'param.mode.label': '模式',
  'param.preset.label': '预设',
  'param.universe.label': '全集大小',
  'param.show-prob.label': '显示概率',
  'param.treat-as-numeric.label': '视为数值',

  'stat.count': '数量',
  'stat.mean': '均值',
  'stat.median': '中位数',
  'stat.range': '极差',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': '四分位距',
  'stat.outliers': '异常值',
  'stat.r': 'Pearson r',
  'stat.r2': 'r²',
  'stat.slope': '斜率',
  'stat.intercept': '截距',
  'stat.n': 'n',
  'stat.population-mean': '真实均值',
  'stat.latest-sample-mean': '样本均值',
  'stat.sample-mean-spread': '样本均值标准差',
  'stat.sample-count': '已抽样本数',
  'outlier.upper': '上侧异常值',
  'outlier.lower': '下侧异常值',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': '重新抽样',
  'btn.run-100': '抽取 100 次',
  'btn.stop': '停止',
  'btn.clear-history': '清除历史',

  'explainer.no-order': '无顺序 → 无累计、无箱线图。',
  'explainer.multi-no-iqr': '多值 → 四分位数 / IQR 未定义。',
  'message.no-data': '无数据。',
  'message.needs-quartiles': '需要 ≥4 个点以计算四分位数。',
  'message.x-zero-variance': 'X 方差为零 — 无法拟合直线。',
  'message.n-too-small': 'n 太小。',
  'message.stratum-clamp': '层中的行数少于请求 — 已使用全部可用。',
  'message.siblings-sum-to-one': '兄弟节点之和必须为 1。',
};
